import PropTypes from 'prop-types';
import {
  Tabs,
  Tab,
  Typography,
  Box,
  IconButton,
  Checkbox
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Page_Padding } from '../../constants';

const TabComponentsForCourse = ({
  tabs,
  value,
  onChange,
  accordionChecks = {},
  handleCheckboxChange,
  isCheckBox = false,
  isPadding = false

}) => {


  const handleNextTab = () => {
    const nextIndex = (value + 1) % tabs.length;
    onChange(null, nextIndex);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 5 }}>
      <Tabs
        value={value}
        onChange={onChange}
        indicatorColor="transparent"
        // variant={"scrollable"}
        scrollButtons={"auto"}
        sx={{
          "& .MuiTabs-flexContainer": {
            flexWrap: "nowrap",
          },
          flexGrow: 1,
          overflowX: "auto",
          px: isPadding ? Page_Padding : "0",
          borderBottom: "1px solid #EEEEEE"
        }}
      >
        {tabs.map((item, index) => {
          const isAllChecked =
            isCheckBox &&
            Array.isArray(accordionChecks?.[index]?.sprints) &&
            accordionChecks[index].sprints.every(sprint => sprint?.checked === true);


          return (
            <Tab
              key={index}
              sx={{
                minWidth: "20%",
                borderBottom: value === index ? "5px solid #DC143C" : "none",
                py: '10px'
              }}
              label={
                <Typography
                  sx={{
                    width: "100%",
                    p: 1,
                    borderRadius: "10px",
                    color: value === index ? 'red.main' : 'inherit',
                    fontWeight: 500,
                    textTransform: "capitalize",
                    bgcolor: value === index ? "#FFECF0" : "inherit",
                    boxShadow: value === index ? "0px 4px 4px 0px #00000040" : "none",
                  }}
                >
                  {
                    isCheckBox && <Checkbox
                      size="small"
                      checked={isAllChecked}
                      onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                      sx={{
                        color: 'red.main',
                        '&.Mui-checked': {
                          color: 'red.main',
                        },
                      }}
                    />
                  }

                  {item.label}
                </Typography>
              }
            />
          );
        })}
      </Tabs>



      <IconButton
        sx={{
          p: 1, mr: 2,
          bgcolor: "#FFEAEA",
          '&:hover': {
            bgcolor: "#FFEAEA",
          }
        }}
        onClick={handleNextTab}
      >
        <ArrowForwardIosIcon sx={{ fontSize: "20px", color: "red.main" }} />
      </IconButton>

    </Box>
  );
};

TabComponentsForCourse.propTypes = {
  tabs: PropTypes.array.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  accordionChecks: PropTypes.object.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
};

export default TabComponentsForCourse;


